import { ApplicationConfig, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { Observable } from 'rxjs';
import { LOAD_WASM } from 'ngx-scanner-qrcode';
import { AuthGuard } from './shared/guards/auth.guard';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { AuthInterceptor } from './shared/interceptors';

export const appConfig: ApplicationConfig = {
  providers: [AuthGuard, provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })), provideAnimationsAsync(),
    provideHttpClient(withInterceptors([AuthInterceptor])), provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }), provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideLottieOptions({
      player: () => player,
    }),
    {
      provide: 'APP_INITIALIZER',
      useFactory: () => () => {
        return new Observable((observer) => {
          LOAD_WASM().subscribe({
            next: () => {
              observer.complete();
            },
            error: (err) => {
              console.error('Failed to load WASM', err);
              observer.error(err);
            },
          });
        });
      },
      multi: true,
    },]
};
